import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { retrieveTags } from '../../../actions/publishActions';
import { mediaNamesQuery, sortTypes } from '../../../constants/mediaConstants';
import { loadDynamicMediasPerNavigationWithTotalCount } from '../../../services/mediaService';
import debounce from 'lodash/debounce';
import { getDetails } from '../../../services/mediaDisplayService';
import { MediaTag} from '../types';

export const NO_CATALOGS_ID = 'nocatalog';

const useFetchData = (
	isModalOpen: boolean
) => {
	const dispatch = useDispatch<any>();

	const accountId = useSelector((state: any) => state.session.defaultAccountId);
	const refreshMedias = useSelector((state) => (state as any).publish.refreshMedias);

	const [medias, setMedias] = useState([]);
	const [timeQuery, setTimeQuery] = useState('');
	const [tagsQuery, setTagsQuery] = useState('');
	const [totalCount, setTotalCount] = useState(0);
	const [selectedStockProvider, setSelectedStockProvider] = useState('Pexels');
	const [isFetchingData, setIsFetchingData] = useState(false);
	const [{ page, rowsPerPage }, setPaginationInfo] = useState({
		page: 0,
		rowsPerPage: 50,
	});

	const [mediaTags, setMediaTags] = useState<MediaTag[]>([]);

	const fetchLibraryMedias = useCallback(
			debounce((timeQuery: string, tagsQuery: string, page: number, rowsPerPage: number) => {
				let searchMediaQuery =`q=${mediaNamesQuery.mediasAndScenarios}`;

				if (timeQuery) {
					searchMediaQuery += timeQuery;
				}

				if (tagsQuery) {
					searchMediaQuery += tagsQuery;
				}

				loadDynamicMediasPerNavigationWithTotalCount({
					accountId,
					mediaPerPage: rowsPerPage,
					offset: page * rowsPerPage,
					medias: mediaNamesQuery.searchFilterMedias,
					sortType: sortTypes.newest,
					query: searchMediaQuery,
					signal: undefined,
				}).then((response: any = { data: [], count: 0 }) => {
					const { data, count } = response;
					setMedias(data.map((media: any) => getDetails(media)));
					setTotalCount(count);
					setIsFetchingData(false);
				});
		}, 500),
		[]
	);

	const fetchTags = useCallback(() => {
		dispatch(retrieveTags(accountId)).then((data: MediaTag[]) => {
			setMediaTags(data);
		});
	}, [accountId, dispatch]);

	useEffect(() => {
		setPaginationInfo({ page: 0, rowsPerPage: 50 });
		setTotalCount(0);
	}, []);

	useEffect(() => {
		if (!isModalOpen) {
			return;
		}
		fetchTags();
		setIsFetchingData(true);
		fetchLibraryMedias(timeQuery, tagsQuery, page, rowsPerPage);
	}, [timeQuery, tagsQuery, page, rowsPerPage, isModalOpen, refreshMedias]);

	return {
		medias,
		mediaTags,
		totalCount,
		page,
		rowsPerPage,
		selectedStockProvider,
		isFetchingData,
		setTimeQuery,
		setTagsQuery,
		setPaginationInfo,
		setSelectedStockProvider,
	};
};

export default useFetchData;
